import React from "react";
import { Dialog, Box, Typography, Button, Chip, Tooltip } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import { C } from "./reportingUtils";
import { TRIAL_DAYS } from "./biTrial";

// First-entry approval dialog: the user must accept the 30-day free trial.
export default function BITrialConsent({ open, onAccept, onLater, onWalkthrough }) {
  const perks = [
    "Live portfolio dashboards & risk analytics",
    "AI insights, report builder, alerts & scheduled exports",
    "A CrediArc specialist reaches out during the month to help you set up",
  ];
  return (
    <Dialog open={open} onClose={onLater} maxWidth="sm" fullWidth PaperProps={{ sx: { borderRadius: "16px", overflow: "hidden" } }}>
      {/* Banner */}
      <Box sx={{ p: 3.5, background: "linear-gradient(135deg,#0E2A5A 0%,#1C4B9C 55%,#2F6BE0 100%)", color: "#fff", position: "relative", overflow: "hidden" }}>
        <Box sx={{ position: "absolute", right: -50, top: -50, width: 190, height: 190, borderRadius: "50%", background: "rgba(255,255,255,.06)" }} />
        <Chip label="NEW" size="small" sx={{ height: 21, fontWeight: 800, letterSpacing: ".06em", fontSize: 10.5, color: "#0E2A5A", background: "#FFD34E", mb: 1.25 }} />
        <Typography sx={{ fontSize: 23, fontWeight: 800, letterSpacing: "-.01em" }}>Start your 30-day free trial</Typography>
        <Typography sx={{ fontSize: 14, opacity: 0.92, mt: 0.5 }}>
          BI &amp; Reporting is now available to preview — free for {TRIAL_DAYS} days.
        </Typography>
      </Box>

      <Box sx={{ px: 3.5, py: 3 }}>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1.25, mb: 2.5 }}>
          {perks.map((p) => (
            <Box key={p} sx={{ display: "flex", gap: 1.25, alignItems: "flex-start" }}>
              <CheckCircleIcon sx={{ fontSize: 19, color: C.green, mt: "1px" }} />
              <Typography sx={{ fontSize: 14, color: C.slate }}>{p}</Typography>
            </Box>
          ))}
        </Box>

        <Typography sx={{ fontSize: 12.5, color: C.muted, mb: 2.5 }}>
          It's on us — no credit card required. By starting the trial you agree to a {TRIAL_DAYS}-day free
          preview of BI &amp; Reporting; our team will contact you during the month to tailor it to your portfolio.
        </Typography>

        <Box sx={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: 1.25 }}>
          <Tooltip title={`Begin your ${TRIAL_DAYS}-day free preview now — a specialist will reach out during the month`} arrow>
            <Button onClick={onAccept} variant="contained"
              sx={{ textTransform: "none", fontWeight: 800, fontSize: 14.5, borderRadius: "11px", px: 3, py: 1.05, background: C.blue,
                "&:hover": { background: "#2559c4" } }}>
              Accept &amp; start free trial
            </Button>
          </Tooltip>
          {onWalkthrough && (
            <Tooltip title="See a quick guided tour of every feature first" arrow>
              <Button onClick={onWalkthrough} startIcon={<PlayCircleOutlineIcon />}
                sx={{ textTransform: "none", fontWeight: 700, color: C.ink, borderRadius: "11px",
                  border: `1px solid ${C.line}`, px: 2, py: 1.05, "&:hover": { borderColor: C.blue } }}>
                Walk me through it
              </Button>
            </Tooltip>
          )}
          <Tooltip title="Close for now — you can start the trial anytime from this page" arrow>
            <Button onClick={onLater} sx={{ textTransform: "none", fontWeight: 600, color: C.muted, ml: "auto" }}>
              Maybe later
            </Button>
          </Tooltip>
        </Box>
      </Box>
    </Dialog>
  );
}
